import data from '@emoji-mart/data';
import EmojiPicker from '@emoji-mart/react';

/** emoji-mart の onEmojiSelect が返す絵文字。利用しているのは native のみ。 */
export type SelectedEmoji = {
  native: string;
};

type Props = {
  onEmojiSelect: (emoji: SelectedEmoji) => void;
  onClickOutside?: () => void;
  theme?: `light` | `dark`;
  url?: string;
  width?: number;
};

export function Picker({
  onEmojiSelect,
  onClickOutside = () => {},
  theme = 'light',
  width,
}: Props) {
  return (
    <EmojiPicker
      data={data}
      onEmojiSelect={onEmojiSelect}
      theme={theme}
      onClickOutside={onClickOutside}
      perLine={width ? Math.floor(width / 36) : undefined}
    />
  );
}
